import script from "./breadcrumb-simple.vue?vue&type=script&setup=true&lang=ts"
export * from "./breadcrumb-simple.vue?vue&type=script&setup=true&lang=ts"

import "./breadcrumb-simple.vue?vue&type=style&index=0&id=23764570&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23764570"]])

export default __exports__